export const SellerReviewStatus = {
    PENDING: 1,
    APPROVED: 2,
    REJECTED: 3,
    
}